import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { api } from '../api/client.ts';
import type { ReplyClassification } from '../types.ts';

export function Replies() {
  const [filter, setFilter] = useState<ReplyClassification | 'ALL'>('ALL');
  const { data, isLoading } = useQuery({
    queryKey: ['replies', filter],
    queryFn: () => api.listReplies({ classification: filter === 'ALL' ? undefined : filter })
  });

  if (isLoading) return <div>Loading...</div>;

  return (
    <div style={{ padding: '24px' }}>
      <h1>Reply Monitoring</h1>
      
      <div style={{ margin: '20px 0' }}>
        <select value={filter} onChange={e => setFilter(e.target.value as ReplyClassification | 'ALL')} style={{ padding: '8px' }}>
          <option value="ALL">All Replies</option>
          <option value="POSITIVE">Positive</option>
          <option value="QUESTION">Question</option>
          <option value="NEUTRAL">Neutral</option>
          <option value="NOT_NOW">Not Now</option>
          <option value="NOT_INTERESTED">Not Interested</option>
          <option value="UNSUBSCRIBE">Unsubscribe</option>
          <option value="OUT_OF_OFFICE">Out of Office</option>
          <option value="BOUNCE">Bounce</option>
          <option value="UNKNOWN">Unknown</option>
        </select>
      </div>

      <div style={{ display: 'grid', gap: '16px' }}>
        {data?.items?.map(reply => (
          <div key={reply.id} style={{ border: '1px solid #334155', padding: '16px', borderRadius: '8px', background: '#1e293b' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px' }}>
              <strong>{reply.companyName}</strong>
              <span style={{ padding: '4px 8px', borderRadius: '12px', fontSize: '12px', background: '#334155' }}>
                {reply.classification}
              </span>
            </div>
            <div style={{ fontSize: '14px', color: '#94a3b8', marginBottom: '12px' }}>
              {reply.personName} ({reply.fromEmail})
            </div>
            <div style={{ padding: '12px', background: '#334155', borderRadius: '4px', whiteSpace: 'pre-wrap' }}>
              {reply.body}
            </div>
            <div style={{ marginTop: '12px', display: 'flex', justifyContent: 'space-between' }}>
              <span style={{ fontSize: '12px', color: '#64748b' }}>
                Received: {new Date(reply.receivedAt).toLocaleString()}
              </span>
              {(reply.classification === 'POSITIVE' || reply.classification === 'QUESTION') && (
                <button
                  onClick={() => api.createHandoff(reply.prospectId)}
                  style={{ background: '#2563eb', color: 'white', border: 'none', padding: '6px 12px', borderRadius: '4px', cursor: 'pointer' }}
                >
                  Create Handoff Brief
                </button>
              )}
            </div>
          </div>
        ))}
        {data?.items?.length === 0 && (
          <div style={{ textAlign: 'center', color: '#94a3b8', padding: '40px' }}>No replies found.</div>
        )}
      </div>
    </div>
  );
}
